import { registerSW } from "virtual:pwa-register";

/**
 * Регистрацията на service worker-а (`src/sw.ts`, билднат от vite-plugin-pwa
 * като `/sw.js`) — ЕДНО място, идемпотентно: `main.tsx` го вика при старт,
 * а модалът „Известия" (`usePushSubscription`) го ползва, за да стигне до
 * регистрацията за push абонамента. Виж docs/pwa.md.
 *
 * `registerType` е „prompt" (по подразбиране): НИКОГА автоматичен reload при
 * нов worker — касата не бива да се презареди върху отворена сметка.
 * „Нова версия" го казва `VersionCheckNotifier`, човекът натиска „Презареди".
 */
let registration: Promise<ServiceWorkerRegistration | undefined> | null = null;

// Ако плъгинът не извика нито един callback (неподдържан контекст), не
// оставяме извикващия да чака вечно.
const REGISTRATION_TIMEOUT_MS = 10_000;

export function registerAppServiceWorker(): Promise<
  ServiceWorkerRegistration | undefined
> {
  if (typeof navigator === "undefined" || !("serviceWorker" in navigator)) {
    return Promise.resolve(undefined);
  }
  if (!registration) {
    registration = new Promise((resolve) => {
      const timeout = window.setTimeout(
        () => resolve(undefined),
        REGISTRATION_TIMEOUT_MS,
      );
      registerSW({
        immediate: true,
        onRegisteredSW: (_swScriptUrl, swRegistration) => {
          window.clearTimeout(timeout);
          resolve(swRegistration);
        },
        onRegisterError: (error: unknown) => {
          window.clearTimeout(timeout);
          console.error("Service worker registration failed:", error);
          resolve(undefined);
        },
      });
    });
  }
  return registration;
}
